import { useContext } from 'react';
import menuItemsProps from '../interfaces/MenuItemProps';
import ChartContext from '../context/ChartContext';
import StylesProps from '../interfaces/StylesProps';

export interface chartItemProps {
  itemName: string;
  itemImage: string;
  quantity: number;
  itemPrice: number;
  showButtons?: boolean;
}

const useSessionStorage = () => {
  const {setChartTotal} = useContext(ChartContext);
  const sessionStorageHandler = (menuItemEl: menuItemsProps) => {
    const { item_name, image, price } = menuItemEl;
    const chartItem: chartItemProps = {
      itemName: item_name,
      itemImage: image,
      quantity: 1,
      itemPrice: price,
    };

    let chartItemsList: Array<chartItemProps> = [];
    const sessionStorageValue = sessionStorage.getItem('IdaChartItems');

    if (!sessionStorageValue) {
      chartItemsList.push(chartItem);
    } else {
      chartItemsList = JSON.parse(sessionStorageValue);
      const itemIndex = chartItemsList.findIndex(item => item.itemName === chartItem.itemName);

      if (itemIndex !== -1) {
        chartItemsList[itemIndex].quantity += 1;
      } else {
        chartItemsList.push(chartItem);
      }
    }

    sessionStorage.setItem('IdaChartItems', JSON.stringify(chartItemsList));
  };

  const getSessionStorage = () => {
    const sessionStorageList = sessionStorage.getItem('IdaChartItems');
    if(sessionStorageList) {
      return JSON.parse(sessionStorageList);
    }
  };

  const addItemQuantity = (item_name: string, item_price: number, quantity: number) => {
    let chartItemsList: Array<chartItemProps> = [];
    const sessionStorageValue = sessionStorage.getItem('IdaChartItems');

    if (sessionStorageValue) {
      chartItemsList = JSON.parse(sessionStorageValue);
      const itemIndex = chartItemsList.findIndex(item => item.itemName === item_name);

      if (itemIndex !== -1) {
        chartItemsList[itemIndex].quantity += 1;
        setChartTotal((prevValue) => ({
          priceTotal: Number((Number(prevValue.priceTotal) + Number(item_price)).toFixed(2)),
          itemsTotal: prevValue.itemsTotal + 1,
        }));
      };
    };
    sessionStorage.setItem('IdaChartItems', JSON.stringify(chartItemsList));
  };

  const removeItemQuantity = (item_name: string, item_price: number, quantity: number) => {
    let chartItemsList: Array<chartItemProps> = [];
    const sessionStorageValue = sessionStorage.getItem('IdaChartItems');

    if (sessionStorageValue) {
      chartItemsList = JSON.parse(sessionStorageValue);
      const itemIndex = chartItemsList.findIndex(item => item.itemName === item_name);
  
      if (itemIndex !== -1 && chartItemsList[itemIndex].quantity > 0) {
        chartItemsList[itemIndex].quantity -= 1;
  
        setChartTotal((prevValue) => ({
          priceTotal: Number((prevValue.priceTotal - item_price).toFixed(2)),
          itemsTotal: prevValue.itemsTotal - 1,
        }));
  
        // if (chartItemsList[itemIndex].quantity === 0) {
        //   chartItemsList.splice(itemIndex, 1);
        // } 
        // remove o item se chegar a zero
      }
    }
  
    sessionStorage.setItem('IdaChartItems', JSON.stringify(chartItemsList));
  };

  const removeZeroQuantityItems = (itemsList: Array<chartItemProps>) => {
    let chartItemsList: Array<chartItemProps> = [];
    let updatedItemsList: Array<chartItemProps> = [];
    const sessionStorageValue = sessionStorage.getItem('IdaChartItems');

    if (sessionStorageValue) {
      chartItemsList = JSON.parse(sessionStorageValue);      
  
      chartItemsList.forEach(itemEl => {
        if (itemEl.quantity > 0) {
          updatedItemsList.push(itemEl);
        }
      });
    }
  
    sessionStorage.setItem('IdaChartItems', JSON.stringify(updatedItemsList));
  };

  const saveStylesToSessionStorage = (styles: StylesProps) => {
    sessionStorage.setItem('IdaStyles', JSON.stringify(styles));
  };

  const getStylesFromSessionStorage = () => {
    const styles = sessionStorage.getItem('IdaStyles');
    if(styles) {
      return JSON.parse(styles);
    }
  }

  return {sessionStorageHandler, getSessionStorage, addItemQuantity, removeItemQuantity, removeZeroQuantityItems, saveStylesToSessionStorage, getStylesFromSessionStorage};
};

export default useSessionStorage;
